import routeName from '../constant';

const routes = [
    {
        path: 'riskNotice',
        name: routeName.RISK_NOTICE,
        component: () => import('@/views/aplCatl640and631/riskNotice/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '非投資等級債券基金風險預告書', leaveAlert: true, unableBack: true, pageTitle: '非投資等級債券基金風險預告書' },
    },
];

export default routes;
